import * as moment from 'moment';

export default function existSubscriptionPeriod(dateStart, dateFinish): string {
  return `${moment(dateStart).format('ll')} - ${moment(dateFinish).format('ll')}`;
}
